var path = 'js/views/draw-view/draw-view.template.html';
var html = "<div class=design-view> <div class=design-preview> <design-preview editable=true base=true></design-preview> </div> <door-list></door-list> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/js/views/draw-view/draw-view.template.html
// module id = 169
// module chunks = 0